/* ==========================================================================
   Big Gun PDP v3 (2026-10-03). Spec: Strategy/2026-10/pdp-redesign/PDP-Redesign-Spec-2026-10-03.md
   Runs the product page built by sections/product-template.liquid
   (data-section-type="bgv2-product", so the vendor product JS stays off it):
   variants, quantity, add to cart (POST /cart/add.js with the cart drawer
   section, then bgv2:cart:added), sticky bar, gallery and zoom, media row,
   the fit bar against every saved machine, Read more, related parts (Section
   Rendering + the known-fit hook) and recently viewed. Vanilla, deferred,
   no jQuery. Every feature is optional: missing markup means it is skipped.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-bgv2-pdp]');
  if (!root) return;

  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* analytics never blocks */ } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var data = {};
  try { data = JSON.parse((qs('[data-bgv2-pdp-json]') || {}).textContent || '{}'); } catch (e) { data = {}; }
  var variants = data.variants || [];
  var FORMAT = data.money || '${{amount}}';
  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = whole + '.' + n[1];
    return FORMAT.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function whenGarage(cb) {
    var tries = 0;
    (function poll() {
      if (window.BGE && window.BGE.Garage && window.BGE.checkFitment) return cb(window.BGE);
      if (++tries > 60) return cb(null);
      setTimeout(poll, 100);
    })();
  }

  var form = qs('[data-bgv2-form]', root);
  var idInput = form ? qs('[data-bgv2-variant-id]', form) : null;
  var atc = form ? qs('[data-bgv2-atc]', form) : null;
  var sticky = qs('[data-bgv2-psticky]');
  var stickyBtn = sticky ? qs('[data-bgv2-sticky-add]', sticky) : null;
  var status = qs('[data-bgv2-status]', root);

  /* ---- 1. Variants ------------------------------------------------------ */
  function currentVariant() {
    var id = idInput ? String(idInput.value) : '';
    for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
    return variants[0] || null;
  }
  function setAvailable(ok) {
    [atc, stickyBtn].forEach(function (b) {
      if (!b) return;
      b.disabled = !ok;
      if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
    });
    if (atc) {
      var t = qs('[data-add-to-cart-text]', atc) || atc;
      t.textContent = ok ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout');
    }
    if (stickyBtn) stickyBtn.textContent = ok ? (atc ? atc.getAttribute('data-label') : 'Add to cart') : (atc ? atc.getAttribute('data-soldout') : 'Sold out');
    var stock = qs('[data-bgv2-stock]', root);
    if (stock) {
      stock.classList.toggle('is-in', ok);
      stock.classList.toggle('is-out', !ok);
      var st = qs('[data-bgv2-stock-text]', stock);
      if (st) st.textContent = ok ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
    }
  }
  function renderVariant(v, fromUser) {
    if (!v) return;
    if (idInput) idInput.value = v.id;
    var now = qs('[data-bgv2-price-now]', root), was = qs('[data-bgv2-price-was]', root), save = qs('[data-bgv2-price-save]', root);
    if (now) now.textContent = money(v.price);
    var onSale = v.compare > v.price;
    if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(v.compare); }
    if (save) { save.hidden = !onSale; var sa = qs('[data-bgv2-price-save-amt]', save); if (sa && onSale) sa.textContent = money(v.compare - v.price); }
    var aff = qs('.bge-affirm', root);
    if (aff) aff.setAttribute('data-amount', v.price);
    var sp = qs('[data-bgv2-sticky-price]');
    if (sp) sp.textContent = data.dealer && window.BGE_DEALER_PRICES && window.BGE_DEALER_PRICES[v.id] ? window.BGE_DEALER_PRICES[v.id].d : money(v.price);
    if (data.dealer && window.BGE_DEALER_PRICES && window.BGE_DEALER_PRICES[v.id]) {
      var rec = window.BGE_DEALER_PRICES[v.id];
      var da = qs('[data-bge-dealer-amount]', root), dr = qs('[data-bge-dealer-retail]', root);
      if (da) da.textContent = rec.d;
      if (dr) dr.textContent = rec.r;
    }
    var pn = v.title && v.title !== 'Default Title' && variants.length === 1 ? v.title : (v.sku || '');
    qsa('[data-bgv2-pn]').forEach(function (el) { if (pn) el.textContent = pn; });
    setAvailable(!!v.available);
    if (fromUser) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) { /* old browsers keep the URL */ }
      if (v.media) gallery.goToMedia(v.media);
      if (status) status.textContent = (v.title || '') + ', ' + money(v.price) + (v.available ? '' : ', ' + (atc ? atc.getAttribute('data-soldout') : 'Sold out'));
      // Other V2 code (tuner pair price, dealer box) listens for change in the form.
      if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (form && variants.length > 1) {
    var vselect = qs('select.bgv2-pdp__vselect', form);
    if (vselect) { vselect.hidden = true; vselect.setAttribute('aria-hidden', 'true'); vselect.tabIndex = -1; }
    qsa('[data-bgv2-opt]', form).forEach(function (fs) {
      fs.addEventListener('change', function () {
        var chosen = qsa('[data-bgv2-opt]', form).map(function (f) { var r = qs('input:checked', f); return r ? r.value : null; });
        qsa('[data-bgv2-opt]', form).forEach(function (f, i) { var c = qs('[data-bgv2-opt-chosen]', f); if (c && chosen[i]) c.textContent = chosen[i]; });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          if (chosen.every(function (val, k) { return val === null || o[k] === val; })) { match = variants[i]; break; }
        }
        if (match) renderVariant(match, true); else setAvailable(false);
        track('pdp_option', { option: fs.getAttribute('data-bgv2-opt') });
      });
    });
    // Mark option values that never make an available variant with the others chosen
    renderVariant(currentVariant(), false);
  }

  /* ---- 2. Quantity -------------------------------------------------------- */
  qsa('[data-bgv2-qty]', root).forEach(function (g) {
    var input = qs('input', g);
    qsa('[data-bgv2-qty-step]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-bgv2-qty-step'), 10);
        input.value = Math.max(1, Math.min(99, n));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('blur', function () { var n = parseInt(input.value, 10); input.value = isNaN(n) || n < 1 ? 1 : Math.min(99, n); });
  });

  /* ---- 3. Add to cart ------------------------------------------------------
     POST /cart/add.js with the cart drawer section in the same request, then
     bgv2:cart:added; the drawer (assets/bgv2-cart-drawer.js) opens from it.
     No drawer on the page: go to /cart. No JS at all: the form posts. */
  function addToCart(source) {
    if (!form || !idInput) return Promise.reject(new Error('no form'));
    var fd = new FormData(form);
    var hasDrawer = !!(window.BGV2CD || (window.BGV2 && window.BGV2.CartDrawer));
    if (hasDrawer) { fd.append('sections', 'bgv2-cart-drawer'); fd.append('sections_url', '/'); }
    document.dispatchEvent(new CustomEvent('bgv2:cart:adding'));
    // A dropped connection or a non-JSON page (a 429) rejects with 'error', which the caller shows as its own
    // line only; Shopify's readable reason still leads when it sends one (CR-07).
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .catch(function () { throw new Error('error'); })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { if (!r.ok || !j) throw new Error((j && (j.description || j.message)) || 'error'); return j; }); })
      .then(function (j) {
        var items = j.items || [j];
        var v = currentVariant();
        // Shopify's Google channel already sends GA4 add_to_cart for every add; this only records the PDP surface.
        track('pdp_add', { source: source, item_id: v && (v.sku || v.title), value: v ? v.price / 100 : undefined, quantity: parseInt(fd.get('quantity') || '1', 10) });
        document.dispatchEvent(new CustomEvent('bgv2:cart:added', { detail: { items: items, source: source, sections: j.sections || null } }));
        if (!hasDrawer) window.location.href = '/cart';
        return j;
      });
  }
  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.dataset.prev = btn.textContent; }
    else btn.removeAttribute('aria-busy');
    var t = qs('[data-add-to-cart-text]', btn) || btn;
    t.textContent = label;
  }
  if (form) {
    // One add in flight for both buttons (inline and sticky): a double tap on a slow phone
    // posted twice and put 2 pipes in the cart (CR-04). The button stays enabled for focus.
    var adding = false;
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter || atc;
      if (submitter && submitter.disabled) { e.preventDefault(); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (adding) return;
      adding = true;
      var source = submitter === stickyBtn ? 'pdp_sticky' : 'pdp';
      var btn = submitter === stickyBtn ? stickyBtn : atc;
      var err = qs('[data-bgv2-atc-error]', root);
      if (err) err.hidden = true;
      busy(btn, true, atc ? atc.getAttribute('data-busy') : 'Adding...');
      addToCart(source).then(function () {
        adding = false;
        busy(btn, false, atc ? atc.getAttribute('data-done') : 'Added');
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); busy(btn, false, atc ? atc.getAttribute('data-label') : 'Add to cart'); }, 1500);
      }).catch(function (ex) {
        adding = false;
        busy(btn, false, atc ? atc.getAttribute('data-label') : 'Add to cart');
        if (err) { err.textContent = (ex && ex.message && ex.message !== 'error' ? ex.message + ' ' : '') + (root.getAttribute('data-err') || 'That did not go through. Try again or call (714) 970-0423.'); err.hidden = false; }
      });
    }, true);
  }

  /* ---- 4. Sticky bar: on whenever the inline Add to cart is out of view ---- */
  if (sticky && atc && 'IntersectionObserver' in window) {
    var atcVisible = true;
    // Any open layer above the page, at every width: the drawers and the phone menu and sign-in (body classes) and
    // any header panel (the desktop sign-in, mega and garage panels set aria-expanded on their trigger). The bar
    // steps out, hidden and inert, and comes back at the same scroll state when the layer closes (FL1-01).
    var header = document.getElementById('shopify-section-header');
    var panelOpen = function () {
      var b = document.body.classList;
      if (b.contains('bge-garage-open') || b.contains('bgv2-cd-open') || b.contains('open_Cart') || b.contains('open_menu') ||
        b.contains('open_Account') || b.contains('open_Sidebar')) return true;
      return !!(header && header.querySelector('[aria-expanded="true"]'));
    };
    var blocked = function () {
      if (panelOpen()) return true;
      var a = document.activeElement;
      return !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== 'radio' && a.type !== 'checkbox');
    };
    var update = function () {
      var on = !atcVisible && !blocked();
      sticky.classList.toggle('is-panel', panelOpen());
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      document.body.classList.toggle('bgv2-psticky-on', on);
      if (on && !sticky.dataset.seen) { sticky.dataset.seen = '1'; track('pdp_sticky_view', {}); }
    };
    new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(atc);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', function () { setTimeout(update, 0); });
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (header) new MutationObserver(update).observe(header, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
    // Desktop: the bar sits under the sticky header.
    var setTop = function () {
      var h = qs('.header-sticky.is-sticky') || qs('.header-sticky');
      var top = h && window.getComputedStyle(h).position === 'fixed' ? h.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--pdp-sticky-top', Math.round(top) + 'px');
      // Desktop: the bar itself sits under the header, so in-page anchors clear both (WG-02).
      var bar = window.matchMedia('(min-width: 1025px)').matches ? sticky.offsetHeight : 0;
      document.documentElement.style.setProperty('--pdp-psticky-h', Math.round(bar) + 'px');
    };
    setTop();
    window.addEventListener('scroll', function () { if (!setTop.t) setTop.t = requestAnimationFrame(function () { setTop(); setTop.t = 0; }); }, { passive: true });
  }

  /* ---- 5. Gallery, zoom, media row ----------------------------------------- */
  var gallery = (function () {
    var gal = qs('[data-bgv2-gal]', root);
    var api = { goTo: function () {}, goToMedia: function () {} };
    if (!gal) return api;
    var track_ = qs('[data-bgv2-gal-track]', gal);
    // FL2-24 (R5-03): focusable and named only for JS off; with JS the zoom buttons and thumbs carry the keyboard.
    if (track_) { track_.setAttribute('tabindex', '-1'); track_.removeAttribute('role'); track_.removeAttribute('aria-label'); }
    var slides = qsa('[data-bgv2-gal-slide]', gal);
    var thumbs = qsa('[data-bgv2-gal-go]', gal);
    var now = qs('[data-bgv2-gal-now]', gal);
    var idx = 0;
    function setIdx(i) {
      if (i === idx) return;
      idx = i;
      if (now) now.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    api.goTo = function (i, smooth) {
      var s = slides[i]; if (!s) return;
      track_.scrollTo({ left: s.offsetLeft - track_.offsetLeft, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      setIdx(i);
    };
    api.goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) return api.goTo(i, true);
    };
    if (slides.length > 1) {
      var tick = 0;
      track_.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = 0;
          var w = track_.clientWidth || 1;
          setIdx(Math.round(track_.scrollLeft / w));
        });
      }, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { api.goTo(k, true); track('pdp_gallery', { action: 'thumb' }); }); });
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { api.goTo(Math.min(slides.length - 1, idx + 1), true); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { api.goTo(Math.max(0, idx - 1), true); e.preventDefault(); }
      });
      var swiped = false;
      track_.addEventListener('touchend', function () { if (!swiped) { swiped = true; track('pdp_gallery', { action: 'swipe' }); } }, { passive: true });
    }
    // Zoom: native dialog, full resolution, Escape closes, focus returns.
    var dlg = qs('[data-bgv2-zoom]');
    var dimg = dlg ? qs('[data-bgv2-zoom-img]', dlg) : null;
    var opener = null;
    qsa('[data-bgv2-gal-zoom]', gal).forEach(function (b) {
      b.addEventListener('click', function () {
        var img = qs('img', b.parentNode);
        if (!dlg || !img || typeof dlg.showModal !== 'function') return;
        opener = b;
        dimg.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
        dimg.alt = img.alt || '';
        dlg.showModal();
        track('pdp_gallery', { action: 'zoom' });
      });
    });
    if (dlg) {
      var close = function () { if (dlg.open) dlg.close(); };
      qs('[data-bgv2-zoom-close]', dlg).addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { if (opener) opener.focus(); });
    }
    // External video: swap the poster for the player on tap.
    qsa('[data-bgv2-gal-ext]', gal).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = b.getAttribute('data-bgv2-gal-ext');
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.title = b.getAttribute('aria-label') || 'Video';
        b.parentNode.replaceChild(f, b);
        track('pdp_gallery', { action: 'video' });
      });
    });
    return api;
  })();
  qsa('[data-bgv2-media]', root).forEach(function (b) {
    b.addEventListener('click', function (e) {
      var kind = b.getAttribute('data-bgv2-media');
      track('pdp_media', { kind: kind });
      if (kind === 'video' && !b.hasAttribute('data-toggle')) {
        var slides = qsa('[data-bgv2-gal-slide]', root);
        for (var i = 0; i < slides.length; i++) if (qs('video, [data-bgv2-gal-ext]', slides[i])) { gallery.goTo(i, true); break; }
      }
      if (kind === 'audio') {
        var clip = qs('[data-bgv2-sound-clip]');
        if (clip) { e.preventDefault(); qs('#bgv2-sound').scrollIntoView({ block: 'center' }); try { clip.play(); } catch (ex) { /* user can press play */ } }
      }
    });
  });

  /* ---- 6. Fit bar: every saved machine, best state wins ---------------------- */
  (function fitBar() {
    var bar = qs('[data-bgv2-fitbar]', root);
    if (!bar || bar.hasAttribute('data-dealer')) return;
    var text = qs('[data-bgv2-fit-text]', bar), sub = qs('[data-bgv2-fit-sub]', bar), acts = qs('[data-bgv2-fit-acts]', bar), ico = qs('[data-bgv2-fit-ico]', bar);
    var stickyFit = qs('[data-bgv2-sticky-fit]');
    var staticText = bar.getAttribute('data-static');
    var stickyStatic = stickyFit ? stickyFit.textContent : '';
    var orig = { text: text ? text.innerHTML : '', sub: sub ? sub.innerHTML : '', acts: acts ? acts.innerHTML : '' };
    var ICONS = {
      static: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>',
      fits: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
      years: '<path d="M12 3 2 20h20L12 3z"/><path d="M12 10v4M12 17.5v.01"/>',
      nofit: '<path d="M6 6l12 12M18 6 6 18"/>',
      info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.01"/>'
    };
    var RANK = { fits: 4, wrong_year: 3, universal: 2, no_fit: 1, untagged: 1, unknown: 0 };
    var tracked = '';
    function set(state, icon, line, subline, actions) {
      bar.className = 'bgv2-fitbar is-' + state;
      if (ico) ico.innerHTML = ICONS[icon] || ICONS.static;
      if (text) text.innerHTML = line;
      if (sub) { sub.innerHTML = subline || ''; sub.hidden = !subline; }
      if (acts) acts.innerHTML = actions || '';
    }
    function modelName(v) { return [v.make, v.model].filter(Boolean).join(' '); }
    function shortName(v) { return v.model || v.make; }
    function joinAnd(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
    function act(label, attrs) { return '<button type="button" ' + (attrs || '') + '>' + esc(label) + '</button>'; }
    function link(label, href, cls) { return '<a href="' + esc(href) + '"' + (cls ? ' class="' + cls + '"' : '') + ' data-bgv2-fit-recovery>' + esc(label) + '</a>'; }
    var CHANGE = act('Change machine', 'data-bge-action="open-drawer"');

    // Other years: look for the sibling version (same type, same series, same
    // configuration) that covers the rider's year, through the garage filter's
    // collection index. Cached per session.
    function findSibling(BGE, v) {
      var fit = bar.getAttribute('data-fit');
      if (!fit) return Promise.resolve(null);
      var handle = fit.replace(/^fit_/, '') + '-exhaust';
      var key = 'bgv2_fitidx:' + handle;
      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { cached = null; }
      var get = cached ? Promise.resolve(cached) : fetch('/collections/' + handle + '?view=bge-fit').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var m = html.match(/<script[^>]*id="bge-fit-index"[^>]*>([\s\S]*?)<\/script>/);
        var rows = m ? (JSON.parse(m[1]).products || []) : [];
        try { sessionStorage.setItem(key, JSON.stringify(rows)); } catch (e) { /* full storage */ }
        return rows;
      }).catch(function () { return []; });
      var myTags = (bar.getAttribute('data-tags') || '').split('|');
      var mySeries = BGE.parseTags(bar.getAttribute('data-tags')).series[0] || '';
      var myHandle = bar.getAttribute('data-handle');
      var myDual = /dual/i.test(bar.getAttribute('data-title') || '');
      var myType = bar.getAttribute('data-type');
      return get.then(function (rows) {
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (r[1] === myHandle || r[3] !== myType) continue;
          if (/dual/i.test(r[1]) !== myDual) continue;
          var p = BGE.parseTags(r[2]);
          if ((p.series[0] || '') !== mySeries) continue;
          if (/black/i.test(r[1]) !== /black/i.test(myHandle)) continue;
          if (BGE.checkFitment(p, v, r[3]) === 'fits') return { handle: r[1], years: p.yearStart && p.yearEnd ? p.yearStart + ' to ' + p.yearEnd : '' };
        }
        return null;
      });
    }

    function resolve(BGE) {
      // Universal parts do not depend on the machine: the server line stands.
      if (bar.hasAttribute('data-universal')) return;
      var vs = BGE && BGE.Garage ? BGE.Garage.list() : [];
      if (!vs.length) {
        var old = BGE && BGE.Garage && BGE.Garage.needsModel ? BGE.Garage.needsModel()[0] : null;
        // A model-less machine of ANOTHER make than this part: no model of it can fit, so say so (call 73); the same make
        // keeps the Pick-the-model prompt (call 7).
        if (old && BGE.checkFitment && BGE.parseTags && BGE.checkFitment(BGE.parseTags(bar.getAttribute('data-tags') || ''), old) === 'no_fit') {
          set('nofit', 'nofit', 'Does not fit your ' + esc(BGE.formatVehicle(old)), staticText ? esc(staticText) + '.' : '', CHANGE);
          if (stickyFit) stickyFit.textContent = 'Does not fit your ' + BGE.formatVehicle(old);
          if (tracked !== 'no_fit') { tracked = 'no_fit'; track('pdp_fit_state', { state: 'no_fit', machines: 0, fits: 0 }); }
          return;
        }
        if (old && BGE.pickModelHtml) {
          // Saved before a model was required: no verdict, one tap to finish the machine.
          set('unknown', 'static', 'Pick the model of your ' + esc(BGE.formatVehicle(old)) + ' to check it fits.', '', BGE.pickModelHtml(old, '', 'Pick your model'));
          // No "Fits 2006 to 2008 ..." beside the add while the rider's machine is unchecked (FL4-12 follow-up). The bar's
          // one line is short ("Pick the model of your 2019 Yamaha" cut to "...your 201..." at 390, FL5-10, call 92); the
          // buy box keeps the full line.
          if (stickyFit) stickyFit.textContent = 'Pick your model';
          if (tracked !== 'needs_model') { tracked = 'needs_model'; track('pdp_fit_state', { state: 'needs_model', machines: 0, fits: 0 }); }
          return;
        }
        if (text) text.innerHTML = orig.text; if (sub) { sub.innerHTML = orig.sub; sub.hidden = false; } if (acts) acts.innerHTML = orig.acts;
        bar.className = 'bgv2-fitbar is-' + (staticText ? 'static' : 'unknown');
        if (ico) ico.innerHTML = ICONS.static;
        if (stickyFit) stickyFit.textContent = stickyStatic;
        return;
      }
      // The active machine first, so it wins a tie (ST-04): with none fitting, the bar
      // names the machine the rider is shopping for, not the first one saved.
      var act0 = BGE.Garage.active();
      if (act0) vs = [act0].concat(vs.filter(function (x) { return x.id !== act0.id; }));
      var parsed = BGE.parseTags(bar.getAttribute('data-tags'));
      var type = bar.getAttribute('data-type');
      var best = { state: 'unknown', v: null }, fitsN = 0;
      vs.forEach(function (v) {
        var s = BGE.checkFitment(parsed, v, type);
        if (s === 'fits') fitsN++;
        if (RANK[s] > RANK[best.state]) best = { state: s, v: v };
      });
      var v = best.v, name = v ? BGE.formatVehicle(v) : '';
      var shopUrl = v && BGE.browseUrl ? BGE.browseUrl(v) : '';
      var years = parsed.yearStart && parsed.yearEnd ? parsed.yearStart + ' to ' + parsed.yearEnd : '';
      switch (best.state) {
        case 'fits':
          set('fits', 'fits', 'Fits your ' + esc(name),
            vs.length > 1 ? 'Checked against your ' + vs.length + ' machines.' : '',
            CHANGE + (shopUrl ? link('Shop all ' + shortName(v) + ' parts', shopUrl) : ''));
          if (stickyFit) stickyFit.textContent = 'Fits your ' + (v.year ? v.year + ' ' : '') + shortName(v);
          break;
        case 'wrong_year':
          set('years', 'years', 'Fits ' + esc(years + ' ' + modelName(v)) + '. Not your ' + esc(v.year) + '.', '', CHANGE + (shopUrl ? link('Shop parts for your ' + v.year + ' ' + shortName(v), shopUrl) : ''));
          bar.classList.add('is-loading');
          findSibling(BGE, v).then(function (sib) {
            bar.classList.remove('is-loading');
            if (!sib || bar.className.indexOf('is-years') < 0) return;
            if (sub) { sub.textContent = 'Your ' + v.year + ' takes the ' + (sib.years || 'other') + ' version.'; sub.hidden = false; }
            if (acts) acts.innerHTML = link('See the ' + (sib.years || 'other') + ' version', '/products/' + sib.handle, 'bgv2-btn bgv2-btn--secondary bgv2-btn--sm') + CHANGE;
          });
          // The sticky bar says the mismatch too, beside its add, as the no_fit branch does (FL4-12).
          if (stickyFit) stickyFit.textContent = 'Not your ' + v.year + ' ' + shortName(v);
          break;
        case 'universal':
          set('universal', 'info', esc(staticText || 'Fits any machine'), '', '');
          if (stickyFit) stickyFit.textContent = stickyStatic;
          break;
        case 'untagged':
          set('untagged', 'info', 'Fitment is not listed for this part.', 'Ask us before you order.', '<a href="mailto:sales@biggunexhaust.com?subject=' + encodeURIComponent('Fitment question: ' + (bar.getAttribute('data-title') || '')) + '">Ask about fitment</a>');
          break;
        case 'no_fit':
          // Several machines, none fitting: say all of them were checked (ST-04).
          set('nofit', 'nofit', vs.length > 1 ? 'Does not fit any of your ' + vs.length + ' machines' : 'Does not fit your ' + esc(name),
            (staticText ? esc(staticText) + '. ' : '') + (vs.length > 1 ? 'Checked against your ' + esc(joinAnd(vs.map(function (x) { return x.year + ' ' + shortName(x); }))) + '.' : ''),
            (shopUrl ? link('Shop ' + shortName(v) + ' parts', shopUrl) : '') + CHANGE);
          if (stickyFit) stickyFit.textContent = vs.length > 1 ? 'Does not fit your ' + vs.length + ' machines' : 'Does not fit your ' + shortName(v);
          break;
        default:
          // 'unknown' (a machine saved without a model, CR-01): back to the server line, never a stale verdict.
          if (text) text.innerHTML = orig.text; if (sub) { sub.innerHTML = orig.sub; sub.hidden = false; } if (acts) acts.innerHTML = orig.acts;
          bar.className = 'bgv2-fitbar is-' + (staticText ? 'static' : 'unknown');
          if (ico) ico.innerHTML = ICONS.static;
          if (stickyFit) stickyFit.textContent = stickyStatic;
      }
      if (tracked !== best.state) { tracked = best.state; track('pdp_fit_state', { state: best.state, machines: vs.length, fits: fitsN }); }
    }
    whenGarage(function (BGE) {
      if (!BGE) return;
      resolve(BGE);
      if (BGE.Garage.onChange) BGE.Garage.onChange(function () { resolve(BGE); });
    });
    bar.addEventListener('click', function (e) { var a = e.target.closest('[data-bgv2-fit-recovery]'); if (a) track('pdp_fit_recovery', { action: a.textContent.trim().slice(0, 40) }); });
  })();

  /* ---- 7. Read more: instant jump (the theme swallows hash links) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bge-read-more]');
    if (!a) return;
    var t = document.getElementById('description');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ block: 'start' });
  });

  /* ---- 8. Ladder clicks, section opens ---------------------------------------- */
  root.addEventListener('click', function (e) { var a = e.target.closest('[data-bgv2-ladder]'); if (a) track('pdp_ladder_click', { series: a.getAttribute('data-bgv2-ladder') }); });
  qsa('details.bgv2-acc', root).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) track('pdp_section_open', { name: (qs('summary', d) || {}).textContent.trim().slice(0, 40) }); }); });

  /* ---- 9. Related parts (Section Rendering + known-fit hook) ---------------- */
  // The rows start hidden (no box, so an observer on them never fires): watch a
  // visible anchor near them instead, the Reviews section at the end of the page.
  var nearAnchor = qs('#bgv2-reviews') || root;
  function whenNear(el, cb) {
    el = nearAnchor;
    if (!('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: '800px 0px' });
    io.observe(el);
  }
  var rel = qs('[data-bgv2-related]');
  if (rel) {
    whenNear(rel, function () {
      var url = '/recommendations/products?product_id=' + rel.getAttribute('data-product-id') + '&limit=12&section_id=' + encodeURIComponent(rel.getAttribute('data-section')) + '&intent=related';
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var list = qs('[data-bgv2-row-list]', tmp);
        // A part's row carries no tuners (FL3-17 N-A15): Power Box and Rev Box cards drop out before the count.
        if (list && rel.hasAttribute('data-no-tuners')) {
          Array.prototype.slice.call(list.children).forEach(function (li) {
            var c = li.querySelector('[data-bge-type]');
            if (c && /^(TFI Power Boxes|Rev Boxes)$/.test(c.getAttribute('data-bge-type') || '')) li.remove();
          });
        }
        if (!list || !list.children.length) { rel.hidden = true; return; }
        var target = qs('[data-bgv2-row-target]', rel);
        target.parentNode.replaceChild(list, target);
        rel.hidden = false;
        rel.setAttribute('data-bgv2-ready', '1');
        document.dispatchEvent(new CustomEvent('bgv2:related:ready', { detail: { root: rel } }));
      }).catch(function () { rel.hidden = true; /* no row rather than an empty placeholder */ });
    });
  }

  /* ---- 10. Recently viewed (no jQuery) ---------------------------------------- */
  (function recent() {
    var KEY = 'bgv2_recent', MAX = 12;
    var me = data.handle;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!list.length) {
      // One-time migration from the vendor cookie (space separated handles).
      var m = document.cookie.match(/(?:^|;\s*)shopify_recently_viewed=([^;]*)/);
      if (m) list = decodeURIComponent(m[1]).split(' ').filter(Boolean);
    }
    var shown = list.filter(function (h) { return h && h !== me; });
    var next = [me].concat(shown).slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* private mode */ }
    var sec = qs('[data-bgv2-recent]');
    if (!sec || !shown.length) return;
    var limit = parseInt(sec.getAttribute('data-limit') || '8', 10);
    var ul = qs('[data-bgv2-row-list]', sec);
    whenNear(sec, function () {
      var take = shown.slice(0, limit);
      Promise.all(take.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=bgv2-row').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        htmls.forEach(function (html) {
          var tmp = document.createElement('ul');
          tmp.innerHTML = html.replace(/<meta[^>]*>/, '');
          var li = qs('li', tmp);
          if (li) ul.appendChild(li);
        });
        if (ul.children.length) {
          sec.hidden = false;
          document.dispatchEvent(new CustomEvent('bgv2:recent:ready', { detail: { root: sec } }));
          if (window.BGE && typeof window.BGE.renderBadges === 'function') window.BGE.renderBadges();
        }
      });
    });
  })();
})();
